// src/utils/auth.js
export default {
    login(userData) {
        sessionStorage.setItem('user', JSON.stringify(userData))
        sessionStorage.setItem('token', userData.token)
    },
    logout() {
        sessionStorage.removeItem('user')
        sessionStorage.removeItem('token')
        // sessionStorage.clear() // caso prefira limpar tudo
    },
    isLoggedIn() {
        return !!sessionStorage.getItem('token')
    },
    getCurrentUser() {
        const user = sessionStorage.getItem('user')
        return user ? JSON.parse(user).data : null
    }
}